
import React, { useState } from 'react';
import '../Filter/Filter.css';
import '../../common/CommonText.css';



const DateFilter = ({ options }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false); 
  };

  return (
    <div className='filter-container'>


      <div className="custom-dropdown" onClick={() => setIsOpen(!isOpen)}>
        
        <div className="selected-option fts-13 lt-gray">
          {selectedOption}
          <span className={`dropdown-icon fts-12 ${isOpen ? 'open' : ''}`}>▼</span>
        </div>
        {isOpen && (
          <ul className="options-list">
            {options.map((option, index) => (
              <li
                key={index}
                className={`option-item dk-gray fts-13 ${selectedOption === option ? 'selected' : ''}`}
                onClick={() => handleOptionClick(option)}
              >
                <span className="check-icon fts-13">{selectedOption === option ? '✔' : ''}</span>
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DateFilter;
